import i18nFactory from '@yandex-int/i18n';
import { Select } from 'lego-on-react';
import * as React from 'react';
import { useCallback, useMemo } from 'react';

import { Loader } from '../../../components/Loader/Loader';
import { Bem } from '../../../service/Bem/Bem';
import { CanvasAppContext, CanvasAppContextProps } from '../../common/typings';
import { DisclaimerCountry, DisclaimerGroup } from '../typings';

import './CreativeDisclaimerOption.css';
import * as keyset from './CreativeDisclaimerOption.i18n';

const i18n = i18nFactory(keyset);

export interface CreativeDisclaimerOptionProps {
    id: string;
    countryId?: string | null;

    items?: DisclaimerCountry[];
    groups?: DisclaimerGroup[];
    change: (id: string) => void;
    countryChange: (countryId: string) => void;
}

const BLOCK = 'creative-disclaimer-option';

export const CreativeDisclaimerOption = React.memo((props: CreativeDisclaimerOptionProps) => {
    if (!props.items || !props.groups || !props.countryId) {
        return <Loader size="xs" />;
    }
    const countries = useMemo(
        () =>
            props.items &&
            props.items.map(item => ({
                val: item.id,
                text: item.name,
                key: item.id
            })),
        [props.items]
    );
    const country = props.items.find(el => String(el.id) === props.countryId);

    if (!country) {
        return null;
    }

    const onCountryChange = useCallback((items: string[]) => props.countryChange(String(items[0])), []);

    const onDisclaimerChange = useCallback((items: string[]) => props.change(String(items[0])), []);

    return (
        <div className={BLOCK}>
            <div className={Bem.cls(BLOCK, 'select-group')}>
                {i18n('country')}

                <CanvasAppContext.Consumer>
                    {({ parent }: CanvasAppContextProps) => (
                        <Select
                            cls={Bem.cls(BLOCK, 'select')}
                            theme={'normal'}
                            size={'xs'}
                            type={'radio'}
                            items={countries}
                            onChange={onCountryChange}
                            val={Number(props.countryId)}
                            popup={{
                                scope: parent || undefined
                            }}
                        />
                    )}
                </CanvasAppContext.Consumer>
            </div>
            <div className={Bem.cls(BLOCK, 'select-group')}>
                {i18n('disclaimer')}

                <CanvasAppContext.Consumer>
                    {({ parent }: CanvasAppContextProps) => (
                        <Select
                            cls={Bem.cls(BLOCK, 'select')}
                            theme={'normal'}
                            size={'xs'}
                            type={'radio'}
                            onChange={onDisclaimerChange}
                            val={Number(props.id)}
                            popup={{
                                scope: parent || undefined
                            }}
                        >
                            {props.groups &&
                                props.groups.map(group => {
                                    const groupItems = country.items.filter(item => item.groupId === group.id);

                                    if (!groupItems.length) {
                                        return null;
                                    }

                                    return (
                                        <Select.Group key={group.id} title={group.name}>
                                            {groupItems.map(item => (
                                                <Select.Item key={item.id} val={item.id}>
                                                    {item.name}
                                                </Select.Item>
                                            ))}
                                        </Select.Group>
                                    );
                                })}
                        </Select>
                    )}
                </CanvasAppContext.Consumer>
            </div>
        </div>
    );
});
